import { createContext } from 'react';

const ThankYouContext = createContext();

export default ThankYouContext;
